import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/sound/edit.png'
import _imports_1 from '@/assets/sound/play.png'
import _imports_2 from '@/assets/sound/pause.png'
import _imports_3 from '@/assets/aivoice/pic_kongyinpin.svg'
import _imports_4 from '@/assets/svg/loding2.gif'


const _hoisted_1 = { class: "timbre" }
const _hoisted_2 = { class: "timbreTop" }
const _hoisted_3 = { class: "topLeft" }
const _hoisted_4 = { class: "topRight" }
const _hoisted_5 = { class: "timbreListBox" }
const _hoisted_6 = { class: "timbreOneInner" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "timbreOneImg" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "playBtn"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "playBtn"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 2,
  class: "setBtn"
}
const _hoisted_16 = { class: "setBtnBox" }
const _hoisted_17 = { class: "timbreOneName" }
const _hoisted_18 = { class: "timbreOneTitle" }
const _hoisted_19 = { class: "timbreOneBtn" }
const _hoisted_20 = { class: "timbreOneBtnInner" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "timbreOneInnerNo"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "noDataPage"
}
const _hoisted_30 = { class: "pieceBoxmask" }
const _hoisted_31 = {
  key: 0,
  class: "pieceBoxmask"
}
const _hoisted_32 = { class: "piecedelBox" }

import {
    Setting
} from "@element-plus/icons-vue";
import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted,getCurrentInstance,watch,onUnmounted } from 'vue'
// 时间处理方法
import {
    formatSeconds
} from "@/components/public-method/time-method";
import delbox from '../commonPage/delPrompt.vue'
// 引入接口
import fileApi from '@/api/sound/depot.ts';
//接口引入
import depotApi from "@/api/sound/depot.ts";

// 默认参数

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { push, currentRoute } = useRouter();
let { proxy } = getCurrentInstance();
// 引入删除模块
const tabIsmine=ref(true)
const tabSelStyle={
    'color':'#fff'
}
const pageNum=ref(1)//当前页数
const pageSize=ref(500)//每页条数
const pageList=ref([])//显示数据
const setBtnShowIndex=ref(-1)
const opendelShow=ref(false)//删除弹窗
const delText=ref('')//删除提示词
const selRole=ref()
// 
const setSel=(index:number,data:any)=>{
    console.log(index)
    setBtnShowIndex.value=index
    selRole.value=data
}
// 删除
const delThis=()=>{
    // console.log('删除')
    delText.value="删除该角色，且永久不可恢复，确认删除？"
    opendelShow.value=true
}
const delFun=()=>{
    console.log('删除回调')
    // pageList.value.splice(setBtnShowIndex.value,1)
    depotApi.delFolder(selRole.value.roleId).then(res=>{
        opendelShow.value=false
        pageList.value.splice(setBtnShowIndex.value,1)
        setBtnShowIndex.value=-1
    }).catch(err=>{
        opendelShow.value=false
    })
}
const closeAll=()=>{
    setBtnShowIndex.value=-1
}
// 切换数据
let timers=null
onUnmounted(()=>{
    clearInterval(timers)
    timers=null
    audioRef.value?.pause()
})
// 我的角色
const tabChangeListMy=()=>{
    console.log(tabIsmine.value)
    fileApi.getisMyList(pageNum.value, pageSize.value,tabIsmine.value).then(res=>{
        console.log(res)
        const numLength=res.rows.filter(item=>item.trainingDuration>0).length
        res.rows.forEach((item:any )=> {
            item.isPlaying=false
            pageList.value.push(item)
        });
        if(numLength>0){
            timers = setInterval(() => {
                
                let haveLength=pageList.value.filter(item=>item.trainingDuration>0).length
                
                if(haveLength==0){
                    clearInterval(timers)
                    timers=null
                }
                pageList.value.filter( item =>{
                    if(item.trainingDuration > 0){
                        item.trainingDuration-=1
                    }
                })
            },1000)
        }
      
    }).catch(err=>{
        pageList.value=[]
    })
}
const tabChangeListPublic=()=>{
    fileApi.getList(pageNum.value, pageSize.value,1).then(res=>{
        console.log(res)
        res.rows.forEach((item:any )=> {
            item.isPlaying=false
            pageList.value.push(item)
        });
      
      
    }).catch(err=>{
        pageList.value=[]
    })
}
onMounted(()=>{
    tabChangeListMy()
})
// 监测Tab切换
watch(tabIsmine,(n,o)=>{
    pageNum.value=1
    pageList.value=[]
    if(n){
        console.log('我的音色')
        tabChangeListMy()
    }else{
        console.log('公共音色')
        tabChangeListPublic()
    }
})
// 跳转到音色克隆页面
const toPageClone=()=>{
    console.log('跳转到音色克隆页面')
    push('/index/soundCloneTimbre')
}
// 播放
const playIndex=ref(-1)
const urlListening=ref('')
const audioRef=ref()
const showlodaing=ref(false)
const selData=ref()
const toPlay =(data:any,index:number)=>{
    console.log(index)
    pageList.value.forEach((item:any )=> {
        item.isPlaying=false
    });
    playIndex.value=index
    if(selData.value == null || data.roleId!=selData.value.roleId){
        selData.value=data
        // showlodaing.value=true
        if(data.demoAudio==undefined){
            depotApi.roleListening(pageList.value[index].roleId).then(res=>{
                console.log(res)
                if(res.code==200){
                    urlListening.value=res.msg
                    setTimeout(()=>{
                        showlodaing.value=false
                        pageList.value[index].isPlaying=true
                        audioRef.value?.play()
                    },100)
                }
                
            }).catch(err=>{
                showlodaing.value=false
                
            })
        }else{
            urlListening.value=data.demoAudio
            setTimeout(()=>{
                showlodaing.value=false
                pageList.value[index].isPlaying=true
                audioRef.value?.play()
            },100)
        }
        
    }else {
            showlodaing.value=false
            pageList.value[index].isPlaying=true
            audioRef.value?.play()   
        }

}
// 暂停
const topause=(index:number)=>{
    pageList.value[index].isPlaying=false
    audioRef.value?.pause()
}
const updateCurrentTime = () => {
    pageList.value[playIndex.value].isPlaying=false
    audioRef.value?.pause()
}
// 生成语音
const creatSound=(data:any)=>{
    console.log('生成语音')
    localStorage.setItem('roleSound',JSON.stringify(data))
    push('/index/soundGeneration')
}
// 变声
const changeSound=(data:any)=>{
    console.log('变声')
    if(data.voiceChangeEnable==0){
        return
    }else{
        localStorage.setItem('roleSound',JSON.stringify(data))
        push('/index/soundChange')
    }
}
// 发布
const torelease=(data:any,index:number)=>{
    console.log('发布')
    fileApi.putRelease(data.roleId).then(res=>{
        console.log(res)
        if(res.code==200){
            pageList.value[index].publishStatus=1
        }
    })
}
// 取消发布
const toNorelease=(data:any,index:number)=>{
    console.log('取消发布')
    fileApi.putCancelRelease(data.roleId).then(res=>{
        console.log(res)
        if(res.code==200){
            pageList.value[index].publishStatus=0
        }
    })
}
onMounted(() => {
  
  proxy.$ws.onmessageCaptionRole = (message: any) => {
    // console.log("tts----------");
    // console.log(message);
    pageList.value=[]
    if(tabIsmine.value){
        console.log('我的音色')
        tabChangeListMy()
    }else{
        console.log('公共音色')
        tabChangeListPublic()
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "styleCommon",
          style: _normalizeStyle(tabIsmine.value?tabSelStyle:''),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (tabIsmine.value=true), ["stop"]))
        }, "我的音色", 4),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "line" }, null, -1)),
        _createElementVNode("span", {
          class: "styleCommon",
          style: _normalizeStyle(!tabIsmine.value?tabSelStyle:''),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (tabIsmine.value=false), ["stop"]))
        }, "公共音色", 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[4] || (_cache[4] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _createElementVNode("span", {
          onClick: _withModifiers(toPageClone, ["stop"])
        }, "克隆音色")
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_scrollbar, null, {
        default: _withCtx(() => [
          (pageList.value?.length>0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "timbreListInner",
                onClick: _withModifiers(closeAll, ["stop"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "timbreOne",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _withDirectives(_createElementVNode("div", {
                        class: "release",
                        onClick: _withModifiers(($event: any) => (torelease(item,index)), ["stop"])
                      }, "发布", 8, _hoisted_7), [
                        [_vShow, item.publishStatus==0&&tabIsmine.value==1]
                      ]),
                      _withDirectives(_createElementVNode("div", {
                        class: "releaseCancel",
                        onClick: _withModifiers(($event: any) => (toNorelease(item,index)), ["stop"])
                      }, "取消发布", 8, _hoisted_8), [
                        [_vShow, item.publishStatus==1&&tabIsmine.value==1]
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("img", {
                          src: _unref(proxy).getimgUrlVoice+item.avatar,
                          alt: "",
                          class: "picOne"
                        }, null, 8, _hoisted_10),
                        (!item.isPlaying)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "",
                                onClick: _withModifiers(($event: any) => (toPlay(item,index)), ["stop"])
                              }, null, 8, _hoisted_12)
                            ]))
                          : _createCommentVNode("", true),
                        (item.isPlaying)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("img", {
                                src: _imports_2,
                                alt: "",
                                onClick: _withModifiers(($event: any) => (topause(index)), ["stop"])
                              }, null, 8, _hoisted_14)
                            ]))
                          : _createCommentVNode("", true),
                        ((item.trainingStatus==100||item.voiceChangeEnable==0)&&tabIsmine.value==true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_el_icon, {
                                size: 20,
                                color: '#5F6365',
                                class: "setBtnInner",
                                onClick: _withModifiers(($event: any) => (setSel(index,item)), ["stop"])
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Setting))
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _withDirectives(_createElementVNode("div", _hoisted_16, [
                                _createElementVNode("span", {
                                  onClick: _withModifiers(delThis, ["stop"])
                                }, "删除")
                              ], 512), [
                                [_vShow, setBtnShowIndex.value==index]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.intro), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("span", {
                            class: "changeBtn",
                            onClick: _withModifiers(($event: any) => (creatSound(item)), ["stop"])
                          }, "生成语音", 8, _hoisted_21),
                          _createElementVNode("span", {
                            class: "soundBtn",
                            onClick: _withModifiers(($event: any) => (changeSound(item)), ["stop"]),
                            style: _normalizeStyle(item.voiceChangeEnable==0?{'background':'#565658'}:'')
                          }, "变声", 12, _hoisted_22)
                        ])
                      ])
                    ]),
                    (item.trainingStatus<100&&item.voiceChangeEnable!=0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          (item.trainingStatus<=1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "等待训练中"))
                            : _createCommentVNode("", true),
                          (item.trainingStatus==2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "变声模型训练中"))
                            : _createCommentVNode("", true),
                          (item.trainingStatus==2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "预计还需"))
                            : _createCommentVNode("", true),
                          (item.trainingStatus==2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_unref(formatSeconds)(item.trainingDuration)), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _createElementVNode("audio", {
                  src: _unref(proxy).getimgUrlVoice + '/' + urlListening.value,
                  controls: "",
                  ref_key: "audioRef",
                  ref: audioRef,
                  onEnded: updateCurrentTime,
                  style: {"display":"none"}
                }, null, 40, _hoisted_28)
              ]))
            : _createCommentVNode("", true),
          (pageList.value?.length==0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "imgBox" }, [
                  _createElementVNode("img", { src: _imports_3 }),
                  _createElementVNode("div", null, "暂无数据")
                ], -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_30, _cache[6] || (_cache[6] = [
      _createElementVNode("div", { class: "maskBox" }, [
        _createElementVNode("img", {
          src: _imports_4,
          style: {"width":"90px","height":"90px"}
        }),
        _createElementVNode("span", null, "正在加载资源中，请稍候...")
      ], -1)
    ]), 512), [
      [_vShow, showlodaing.value]
    ]),
    _createElementVNode("div", null, [
      (opendelShow.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(delbox, {
                text: delText.value,
                onCloseThis: _cache[2] || (_cache[2] = ($event: any) => (opendelShow.value = false)),
                onRecognition: delFun
              }, null, 8, ["text"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})